import { API_TYPE, fetchData } from '@umu/umu-fetch';

const API = {
    NAPI_JSON: {
        url: '/napi/v1/i18n/json',
        type: API_TYPE.GET,
    },
};

export const getRuntimeLangData = async (scope: string): Promise<{ [key: string]: string }> => {
    const resp = await fetchData(API.NAPI_JSON, { scope }, { silent: true });
    return resp.data || resp;
};
